"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IdleWarningBanner;
exports.formatCountdown = formatCountdown;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * IdleWarningBanner — the two-minute warning.
 *
 * Deliberately not a modal. Somebody who is mid-sentence should be able to
 * carry on typing and have the banner clear itself, because typing is activity.
 * A modal would stop them working in order to tell them they are about to stop
 * working.
 *
 * By the time this appears the drafts have already been saved. The banner is a
 * chance to stay, not the safety net. The safety net ran first.
 */function IdleWarningBanner({
  secondsUntilLock,
  onStaySignedIn,
  saving = false
}) {
  const label = formatCountdown(secondsUntilLock);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "idle-warning",
    role: "status",
    "aria-live": "polite",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "idle-warning__text",
      children: ["You will be signed out in ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        className: "idle-warning__count",
        children: label
      }), "."]
    }), saving && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "idle-warning__saving",
      children: "Saving your work\u2026"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      className: "idle-warning__action",
      onClick: onStaySignedIn,
      children: "Stay signed in"
    })]
  });
}

/** "1:05", or "12 seconds" once it is under a minute. */
function formatCountdown(totalSeconds) {
  const seconds = Math.max(0, Math.ceil(Number(totalSeconds) || 0));
  if (seconds < 60) return seconds === 1 ? '1 second' : `${seconds} seconds`;
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return `${minutes}:${String(rest).padStart(2, '0')}`;
}